import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

import { EUserPermissions } from '../../chat/interfaces/EPermissions';
import { PermissionsService } from '../../chat/services/permissions.service';

@Directive({
  selector: '[hasMessagingPermissions]',
  standalone: false,
})
export class HasMessagingPermissionsDirective implements OnInit {
  permissions: EUserPermissions[];

  constructor(
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<unknown>,
    private permissionsService: PermissionsService
  ) {}

  @Input()
  set hasMessagingPermissions(access: EUserPermissions[]) {
    this.permissions = access;
    this.updateView();
  }

  ngOnInit(): void {
    this.updateView();
  }

  updateView() {
    this.viewContainer.clear();
    if (this.permissionsService.checkPermissions(this.permissions)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
